import { zodForgivingSchema } from '../../zod/forgivingSchema';
import z from 'zod';

export const CartSetupCodeRequestType = z.literal(['Default', 'SetupWifi']);

export const CartSetupCodeRequest = z.object({
    sub: z.string(),
    exp: z.coerce.date().nullish(),
    data: z.string().nullish(),
    requestType: CartSetupCodeRequestType.nullish(),
});
export type CartSetupCodeRequest = z.infer<typeof CartSetupCodeRequest>;

export const CartSetupCodeResponse = zodForgivingSchema(
    z.object({
        success: z.boolean(),
        code: z.string(),
        errorMessage: z.string(),
    }),
);
export type CartSetupCodeResponse = z.infer<typeof CartSetupCodeResponse>;
